import React from 'react';
import styled, {css} from 'styled-components/native';
import EditField from './EditField';
import CheckboxButton from './CheckboxButton';
import {ActionButton} from '../button/ActionButton';
import {IsApproved} from '../../utils/helpers';
import {IsHRWeb, DataTypes, IsHRiOS} from '../../Tools/DisplayTools';

const HeaderFields = styled.View`
  display: flex;
  ${IsHRWeb() &&
  css`
    flex-direction: row;
    flex-wrap: wrap;
  `}
`;

const FieldGroup = styled.View`
  display: flex;
  ${IsHRWeb() &&
  css`
    flex-direction: row;
    flex-wrap: wrap;
    align-items: flex-end;
  `}
  width: 100%;
`;

function ShowSingleEditField(field, index, props) {
  let val = props.record[field.dataKey];
  if (field.fixedvalue !== undefined) {
    val = field.fixedvalue;
  }
  if (field.matrixfield) {
    if (props.record.rows && props.record.rows.length > 0) {
      let tval = [];
      for (let i = 0; i < props.record.rows.length; i++) {
        tval.push(props.record.rows[i][field.dataKey]);
      }
      val = tval.join(',');
    }
  }
  if (field.pasteSpecialSearch == true) {
    val = [];
    if (field.fixedvalue !== undefined) {
      if (field.fixedvalue != '') {
        val.push({
          id: field.fixedvalue,
          name: global.pasteSpecialsVector[field.pasteSpecial][
            field.fixedvalue
          ][field.pasteSpecialSearchFields[1]],
        });
      }
    } else {
      if (field.pasteSpecialMulti) {
        if (field.matrixfield) {
          props.record.rows.map(function (row, index) {
            val.push({
              id: row[field.pasteSpecialSearchFields[0]],
              name: row[field.pasteSpecialSearchFields[1]],
            });
          });
        } else {
          props.record[field.dataKey].split2(',').map(function (code, index) {
            let name = '';
            if (
              global.pasteSpecialsVector[field.pasteSpecial][code] !== undefined
            ) {
              name =
                global.pasteSpecialsVector[field.pasteSpecial][code][
                  field.pasteSpecialSearchFields[1]
                ];
            }
            if (code != '') {
              val.push({
                id: code,
                name: name,
              });
            }
          });
        }
      } else {
        if (field.matrixfield) {
          if (props.record.rows && props.record.rows.length > 0) {
            let tstr = props.record.rows[0][field.pasteSpecialSearchFields[1]];
            if (field.pasteSpecialSearchFields.length > 2) {
              tstr +=
                ' ' + props.record.rows[0][field.pasteSpecialSearchFields[2]];
            }
            val.push({
              id: props.record.rows[0][field.pasteSpecialSearchFields[0]],
              name: tstr,
            });
          }
        } else {
          let tstr = props.record[field.pasteSpecialSearchFields[1]];
          if (field.pasteSpecialSearchFields.length > 2) {
            tstr += ' ' + props.record[field.pasteSpecialSearchFields[2]];
          }
          val.push({
            id: props.record[field.pasteSpecialSearchFields[0]],
            name: tstr,
          });
        }
      }
    }
  }
  switch (field.type) {
    case DataTypes.kInputTypeCheckbox:
      return (
        <CheckboxButton
          key={field.dataKey}
          name={field.dataKey}
          title={field.title}
          title2={field.title2}
          tooltip={field.tooltip}
          value={val}
          editable={field.viewOnly == false && IsApproved(props) == false}
          onChange={field.onChange}
        />
      );
    case DataTypes.kInputTypeButton:
      let w = field.width;
      if (w) {
        if (w.indexOf('px') > 0) {
          w = parseInt(w);
        }
        if (IsHRWeb() == false) {
          if (field.type != DataTypes.kInputTypeButton) {
            w = '100%';
          } else {
            w = null;
          }
        }
      }
      return (
        <ActionButton
          onPress={() => {
            field.action();
          }}
          style={{
            width: w,
            ...field.style,
            textAlign: 'center',
          }}
          title={field.title}
        />
      );
    case DataTypes.kInputTypeNone:
      return;
    default:
      return (
        // can just pass field as prop, so then won't have to create so many props
        <EditField
          key={field.dataKey}
          title={field.title}
          value={val}
          record={props.record}
          ps={field.pasteSpecial}
          psfields={field.pasteSpecialFields}
          pssearch={field.pasteSpecialSearch}
          psnocomment={field.pasteSpecialNoComment}
          reference={field.reference}
          psmulti={field.pasteSpecialMulti}
          psnewrec={field.pasteSpecialNewRecord}
          psheader={field.pasteSpecialHeader}
          pssort={field.pasteSpecialSort}
          name={field.dataKey}
          matrixfield={field.matrixfield}
          linkedfield={field.linkedfield}
          onChange={field.onChange}
          onFocus={field.onFocus}
          width={field.width}
          barcode={field.type == DataTypes.kInputTypeBarCode}
          /*viewOnly={field.viewOnly} we have editable and will be using it*/
          row={field.row}
          allowClearing={field.allowClearing}
          editable={
            field.viewOnly == false &&
            IsApproved(props.record, props.okcheck, field.dataKey) == false
          }
          type={field.type ? field.type : DataTypes.kInputTypeText}
          onClick={() => props.onClick()}
          inputStyle={field.style}
        />
      );
  }
}

const FieldSection = (props) => {
  return (
    <HeaderFields style={props.style}>
      {props.fields.map(function (field, index) {
        if (field.hasOwnProperty('group')) {
          let styles = {};
          if (field.group.hasOwnProperty('styles')) {
            styles = field.group.styles;
          }
          if (IsHRiOS() == false) {
            styles.zIndex = props.fields.length - index;
          }
          return (
            <FieldGroup key={index} style={styles}>
              {field.group.fields.map(function (field_inner, index) {
                return ShowSingleEditField(field_inner, index, props);
              })}
            </FieldGroup>
          );
        } else {
          return ShowSingleEditField(field, index, props);
        }
      })}
    </HeaderFields>
  );
};

export default FieldSection;
